import React, { Component } from "react";
import { connect } from "react-redux";
import { Parse } from "parse";
import { StripeProvider } from "react-stripe-elements";
import Header from "../Header/header";
import HeaderContainer from "../Header/LandingHeader/HeaderContainer";
import Footer from "../Footer/footer";
import MyStoreCheckout from "./myStoreCheckout";
import { Contentstyled, ColShadow, Layoutstyled } from "../Constants/style";
import { Row, Col, Button, Input, message } from "antd";
import { Link, Redirect } from "react-router-dom";

class Payment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      price: this.props.location.state.price,
      dietPrice: this.props.location.state.dietPrice,
      finalPrice: this.props.location.state.diet
        ? this.props.location.state.dietPrice + this.props.location.state.price
        : this.props.location.state.price,
      label:
        this.props.location.state.couponType === "extension"
          ? `${this.props.location.state.label} (+ 1 mois offert)`
          : this.props.location.state.label,
      quantity: this.props.location.state.quantity,
      coupon: null,
      redirectAfterCoupon: false,
      couponApplied: this.props.location.state.couponApplied,
      fees: this.props.location.state.fees
    };
    this.initialPrice = this.state.finalPrice;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location !== this.props.location) {
      this.setState({
        price: this.props.location.state.price,
        dietPrice: this.props.location.state.dietPrice,
        finalPrice: this.props.location.state.diet
          ? this.props.location.state.dietPrice +
            this.props.location.state.price
          : this.props.location.state.price,
        label:
          this.props.location.state.couponType === "extension"
            ? `${this.props.location.state.label} (+ 1 mois offert)`
            : this.props.location.state.label,
        quantity: this.props.location.state.quantity,
        couponApplied: this.props.location.state.couponApplied,
        fees: this.props.location.state.fees
      });
    }
  }

  couponChanged = e => {
    this.setState({ coupon: e.target.value });
  };

  getFees() {
    //console.log("on passe dans fees : ", this.state.fees)
    if (this.state.fees === true && !this.props.location.state.couponType) {
      return (
        <div>
          <Row type="flex" justify="space-between" align="middle">
            <Col>
              <p style={{ fontWeight: "bold", fontSize: 16 }}>
                Frais de dossier :
              </p>
            </Col>
          </Row>

          <Row type="flex" justify="end">
            <Col>
              <p
                style={{ fontWeight: "bold", fontSize: 16, textAlign: "right" }}
              >
                {60}€
              </p>
            </Col>
          </Row>
        </div>
      );
    } else if (this.props.location.state.couponType === "dossier") {
      return (
        <div>
          <Row type="flex" justify="space-between" align="middle">
            <Col>
              <p style={{ fontWeight: "bold", fontSize: 16 }}>
                Frais de dossier :
              </p>
            </Col>
          </Row>

          <Row type="flex" justify="end">
            <Col>
              <p
                style={{ fontWeight: "bold", fontSize: 16, textAlign: "right" }}
              >
                OFFERTS
              </p>
            </Col>
          </Row>
        </div>
      );
    }
  }

  getVolume() {
    if (this.props.location.state.volume) {
      if (this.props.location.state.volume > 1) {
        return (
          <div>
            <Row>
              <p style={{ fontWeight: "bold", fontSize: 16 }}>Quantité :</p>
            </Row>
            <Row>
              <p
                style={{ fontWeight: "bold", fontSize: 14, textAlign: "right" }}
              >
                {this.props.location.state.volume} séances individuelles
              </p>
            </Row>
          </div>
        );
      } else {
        return (
          <div>
            <Row>
              <p style={{ fontWeight: "bold", fontSize: 16 }}>Quantité :</p>
            </Row>
            <Row>
              <p
                style={{ fontWeight: "bold", fontSize: 14, textAlign: "right" }}
              >
                {this.props.location.state.volume} séance individuelle
              </p>
            </Row>
          </div>
        );
      }
    }
  }

  getPricing() {
    if (
      !this.props.location.state.fees &&
      (!this.state.duration || this.state.duration < 1)
    ) {
      return (
        <div>
          <Row>
            <p style={{ fontWeight: "bold", fontSize: 16, color: "#0000FE" }}>
              Prix total :
            </p>
          </Row>
          <Row>
            <p
              style={{
                fontWeight: "bold",
                fontSize: 16,
                color: "#0000FE",
                textAlign: "right"
              }}
            >
              {this.state.finalPrice}€
            </p>
          </Row>
        </div>
      );
    } else if (!this.props.location.state.fees && this.state.duration > 1) {
      return (
        <div>
          <Row align="middle">
            <p style={{ fontWeight: "bold", fontSize: 16 }}>Tarif mensuel :</p>
          </Row>
          <Row>
            <p style={{ fontWeight: "bold", fontSize: 16, textAlign: "right" }}>
              {this.state.finalPrice}€
            </p>
          </Row>
        </div>
      );
    } else if (this.props.location.state.couponType === "dossier") {
      return (
        <div>
          <Row>
            <p style={{ fontWeight: "bold", fontSize: 16 }}>Tarif mensuel :</p>
            <p style={{ fontWeight: "bold", fontSize: 16, textAlign: "right" }}>
              {this.state.finalPrice}€
            </p>
          </Row>
          <Row>
            <p style={{ fontWeight: "bold", fontSize: 16, color: "#0000FE" }}>
              À payer maintenant :
            </p>
            <p
              style={{
                fontWeight: "bold",
                fontSize: 16,
                color: "#0000FE",
                textAlign: "right"
              }}
            >
              {this.state.finalPrice}€
            </p>
          </Row>
        </div>
      );
    } else {
      return (
        <div>
          <Row>
            <p style={{ fontWeight: "bold", fontSize: 16 }}>Tarif mensuel :</p>
            <p style={{ fontWeight: "bold", fontSize: 16, textAlign: "right" }}>
              {this.state.finalPrice}€
            </p>
          </Row>
          <Row>
            <p style={{ fontWeight: "bold", fontSize: 16, color: "#0000FE" }}>
              À payer maintenant :
            </p>
            <p
              style={{
                fontWeight: "bold",
                fontSize: 16,
                color: "#0000FE",
                textAlign: "right"
              }}
            >
              {this.state.finalPrice + 60}€
            </p>
          </Row>
        </div>
      );
    }
  }

  checkCoupon = async () => {
    let coupon = this.state.coupon;
    if (this.state.couponApplied === true) {
      return message.error("La réduction a déjà été appliquée !");
    }
    try {
      let myCoupon = await Parse.Cloud.run("checkCoupon", {
        coupon: coupon
      });
      //changer les libellés et prix avant de redirect
      console.log("myCoupon : ", myCoupon);
      this.price = this.state.price;

      let type = myCoupon.type;
      if (!type && myCoupon.amount_off) {
        console.log("sur un coupon stripe")
        //on est sur un coupon Stripe
        // il faut ne bouger que le premier prix ? voir comment réagit stripe
        console.log("new price: ", this.price)
        /*this.discount = `Prix avant remise :
        ${this.initialPrice}€`;*/
        this.setState({
          redirectAfterCoupon: true,
          couponApplied: true,
          finalPrice: this.price - (myCoupon.amount_off/100),
          couponType: myCoupon.id
        });
      } else if (type === "extension") {
        this.setState({
          redirectAfterCoupon: true,
          couponApplied: true,
          couponType: "extension"
        });
        return;
      } else if (type === "dossier") {
        this.setState({
          redirectAfterCoupon: true,
          couponApplied: true,
          fees: false,
          couponType: "dossier"
        });
        return;
      } else if (type === "gratuit") {
        console.log("label: ", this.props.location.state.label);
        if (this.props.location.state.label === "Séance Urban'Addict") {
          this.price = 0;
          this.setState({
            redirectAfterCoupon: true,
            couponApplied: true,
            couponType: "gratuit"
          });
        } else {
          message.error("Ce code promo n'est pas valable pour cette offre.");
        }
        return;
      } else if (type === "reduction") {
        if (
          (this.props.location.state.label ===
            "Abonnement Urban'Addict - 9 mois" &&
            myCoupon.code === "STUDENTURBAN") ||
          (this.props.location.state.label ===
            "Abonnement Urban'Addict - 3 mois" &&
            myCoupon.code === "HAPPYCOACHING")
        ) {
          console.log("ok pour réduction");
          console.log("this.price: ", this.price);
          let discount = myCoupon.discount;

          this.price = this.state.price - discount;
          console.log("this.price2: ", this.price);

          this.discount = `Prix avant remise :
      ${this.initialPrice}€`;
          this.setState({
            redirectAfterCoupon: true,
            couponApplied: true,
            couponType: "reduction"
          });
        } else {
          return message.error(
            "Ce code promo n'est pas valable pour cette offre."
          );
        }
      }
    } catch (error) {
      console.log("error: ", error);
      message.error(error.message);
    }
  };

  onRenderCoupon = () => {
    if (!this.state.couponApplied) return;
    return (
      <div>
        <p style={{ fontWeight: "bold", fontSize: 16, textAlign: "right" }}>
          {this.discount}
        </p>
        <p style={{ fontStyle: "italic", fontSize: 12, textAlign: "right" }}>
          {" "}
          Réduction appliquée !{" "}
        </p>
      </div>
    );
  };

  onRenderBasket = () => {
    if (this.props.location.state.diet === true) {
      return (
        <div>
          <Row type="flex" justify="space-between" align="middle">
            <Col>
              <p style={{ fontWeight: "bold", fontSize: 16 }}>
                {this.state.label} :
              </p>
            </Col>
          </Row>

          <Row type="flex" justify="end">
            <Col>
              <p
                style={{ fontWeight: "bold", fontSize: 16, textAlign: "right" }}
              >
                {this.state.price}€
              </p>
            </Col>
          </Row>
          <Row type="flex" justify="space-between" align="middle">
            <Col>
              <p
                style={{
                  fontWeight: "bold",
                  fontSize: 16,
                  marginBottom: "25px",
                  textAlign: "right"
                }}
              >
                Option diététicien incluse :
              </p>
            </Col>
            <Col>
              <p
                style={{
                  fontWeight: "bold",
                  fontSize: 16,
                  marginBottom: "25px",
                  textAlign: "right"
                }}
              >
                {this.state.dietPrice}€
              </p>
            </Col>
          </Row>
          {this.getFees()}
          {this.getVolume()}
          {this.onRenderCoupon()}
          {this.getPricing()}
        </div>
      );
    } else {
      return (
        <div>
          <Row type="flex" justify="space-between" align="middle">
            <Col>
              <p style={{ fontWeight: "bold", fontSize: 16 }}>
                {this.state.label} :
              </p>
            </Col>
          </Row>

          <Row type="flex" justify="end">
            <Col>
              <p
                style={{ fontWeight: "bold", fontSize: 16, textAlign: "right" }}
              >
                {this.state.finalPrice}€
              </p>
            </Col>
          </Row>

          {this.getFees()}
          {this.getVolume()}
          {this.onRenderCoupon()}
          {this.getPricing()}
        </div>
      );
    }
  };

  render() {
    if (this.props.location.state === undefined) {
      return <Redirect to="/purchase" />;
    }
    if (this.state.redirectAfterCoupon === true) {
      this.setState({ redirectAfterCoupon: false });
      console.log("this.price: ", this.price);
      return (
        <Redirect
          to={{
            pathname: "/payment",
            state: {
              ...this.props.location.state,
              price: this.price,
              fees: this.state.fees,
              discount: this.discount,
              couponApplied: true,
              couponType: this.state.couponType
            }
          }}
        />
      );
    } else {
      return (
        <Layoutstyled>
          <Header />
          <HeaderContainer />
          <Contentstyled>
            <Row type="flex" justify="space-around" align="top">
              <Col
                xs={24}
                sm={24}
                md={8}
                lg={8}
                xl={8}
                style={{ marginBottom: "35px" }}
              >
                <ColShadow
                  style={{
                    background: "#fff",
                    padding: 24,
                    radius: 4,
                    marginBottom: "35px"
                  }}
                >
                  <Row
                    type="flex"
                    justify="space-between"
                    align="middle"
                    style={{ marginBottom: "25px" }}
                  >
                    <h4>Mon panier :</h4>
                    <img
                      alt={"caddie"}
                      src={require("../img/shoppingcart.png")}
                      style={{ width: "24px", height: "24px" }}
                    />
                  </Row>
                  {this.onRenderBasket()}
                  <Row
                    type="flex"
                    justify="end"
                    align="middle"
                    style={{ marginTop: "25px" }}
                  >
                    <Link
                      to={{
                        pathname: "/purchase"
                      }}
                    >
                      <Button type="danger">Annuler</Button>
                    </Link>
                  </Row>
                </ColShadow>
                <ColShadow
                  style={{
                    background: "#fff",
                    padding: 24,
                    radius: 4
                  }}
                >
                  <h4>CODE PROMO :</h4>
                  <p>Vous disposez d'un code promo Urban'Fitness ?</p>
                  <p>
                    Entrez votre code ci-dessous afin de pouvoir en profiter
                    pour votre achat.
                  </p>
                  <Row type="flex" justify="space-between" align="top">
                    <Col
                      xs={24}
                      sm={24}
                      md={16}
                      lg={16}
                      xl={16}
                      style={{ marginBottom: "15px", paddingTop: "10px" }}
                    >
                      <Input
                        placeholder="Votre code promo"
                        onChange={this.couponChanged}
                      />
                    </Col>
                    <Col
                      xs={24}
                      sm={24}
                      md={6}
                      lg={6}
                      xl={6}
                      style={{ paddingTop: "15px" }}
                    >
                      <Button onClick={this.checkCoupon} type="primary">
                        Valider
                      </Button>
                    </Col>
                  </Row>
                </ColShadow>
              </Col>
              <Col xs={24} sm={24} md={14} lg={14} xl={14}>
                <ColShadow
                  style={{ background: "#fff", padding: 24, radius: 10 }}
                >
                  <StripeProvider apiKey="pk_live_8vFd08iZU0t9H7QFg032ZNms">
                {/* <StripeProvider apiKey="pk_test_G2xtUxZaFfggucGs2jhkHzYR">*/}
                    <MyStoreCheckout {...this.props.location.state} />
                  </StripeProvider>
                </ColShadow>
              </Col>
            </Row>
          </Contentstyled>
          <Footer />
        </Layoutstyled>
      );
    }
  }
}

const mapStateToProps = globalReducers => globalReducers;
const connectedPayment = connect(
  mapStateToProps,
  null
)(Payment);
export default connectedPayment;
